<div class="w-full h-full text-muted-color font-inter relative">
    @for (timeslot of timeslots; track timeslot; let i = $index) {
        @if (i % 4 == 0) {
            <div
                class="text-[12px] text-color leading-[10px] right-0 font-medium absolute"
                [style.top.px]="i * 48"
                >{{ timeslot }}</div
            >
        } @else {
            <div
                class="text-[10px] text-muted-color right-0 leading-3 font-semibold tracking-[.48px] absolute"
                [style.top.px]="i * 48 - 4"
                >{{ timeslot }}</div
            >
        }
    }
</div>
